import { REBALANCE_MAP_COLS } from '../../enums/';

export type ResourceType = 'portfolio_holdings' | 'app_portfolio_holdings';

export const columnGroups = {
  Date: [REBALANCE_MAP_COLS.DATE],
  Identifiers: [
    REBALANCE_MAP_COLS.TICKER,
    REBALANCE_MAP_COLS.COUNTRY,
    REBALANCE_MAP_COLS.CUSIP,
    REBALANCE_MAP_COLS.ISIN,
    REBALANCE_MAP_COLS.SEDOL,
    REBALANCE_MAP_COLS.BLOOMBERG_TICKER,
  ],
  Details: [
    REBALANCE_MAP_COLS.NAME,
    REBALANCE_MAP_COLS.PRICE,
    REBALANCE_MAP_COLS.SHARE_COUNT,
    REBALANCE_MAP_COLS.CURRENCY,
    REBALANCE_MAP_COLS.BROKER,
    REBALANCE_MAP_COLS.DESCRIPTION,
    REBALANCE_MAP_COLS.ASSET_TYPE,
    REBALANCE_MAP_COLS.MARKET_VALUE,
  ],
  Other: [
    REBALANCE_MAP_COLS.ASSET_ENTITY,
    REBALANCE_MAP_COLS.COST,
    REBALANCE_MAP_COLS.INVESTMENT_DATE,
    REBALANCE_MAP_COLS.UNREALIZED_GAIN_LOSS_BOOK,
    REBALANCE_MAP_COLS.ITD_PL,
    REBALANCE_MAP_COLS.YTD_PL,
    REBALANCE_MAP_COLS.QTD_PL,
    REBALANCE_MAP_COLS.MTD_PL,
    REBALANCE_MAP_COLS.DTD_PL,
    REBALANCE_MAP_COLS.COMMITED_AMOUNT,
    REBALANCE_MAP_COLS.CALLED_CAPITAL,
    REBALANCE_MAP_COLS.ITD_DISTRIBUTIONS,
    REBALANCE_MAP_COLS.ITD_RETURN_OF_CAPITAL,
    REBALANCE_MAP_COLS.INTERNAL_RATE_OF_RETURN,
  ],
};

/**
 * Maps each column field to which resource types it's available for
 * 'all' means available for all resource types
 */
export const columnResourceTypes: Record<string, 'all' | ResourceType | ResourceType[]> = {
  [REBALANCE_MAP_COLS.DATE]: 'all',
  [REBALANCE_MAP_COLS.TICKER]: 'all',
  [REBALANCE_MAP_COLS.COUNTRY]: 'all',
  [REBALANCE_MAP_COLS.CUSIP]: 'all',
  [REBALANCE_MAP_COLS.ISIN]: 'all',
  [REBALANCE_MAP_COLS.SEDOL]: 'all',
  [REBALANCE_MAP_COLS.BLOOMBERG_TICKER]: 'all',
  [REBALANCE_MAP_COLS.NAME]: 'all',
  [REBALANCE_MAP_COLS.PRICE]: 'all',
  [REBALANCE_MAP_COLS.SHARE_COUNT]: 'all',
  [REBALANCE_MAP_COLS.CURRENCY]: 'all',
  [REBALANCE_MAP_COLS.BROKER]: 'all',
  [REBALANCE_MAP_COLS.DESCRIPTION]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.ASSET_TYPE]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.MARKET_VALUE]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.ASSET_ENTITY]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.COST]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.INVESTMENT_DATE]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.UNREALIZED_GAIN_LOSS_BOOK]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.ITD_PL]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.YTD_PL]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.QTD_PL]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.MTD_PL]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.DTD_PL]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.COMMITED_AMOUNT]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.CALLED_CAPITAL]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.ITD_DISTRIBUTIONS]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.ITD_RETURN_OF_CAPITAL]: 'app_portfolio_holdings',
  [REBALANCE_MAP_COLS.INTERNAL_RATE_OF_RETURN]: 'app_portfolio_holdings',
};

/**
 * Checks if a column field should be visible for the given resource type
 */
export const isColumnVisibleForResourceType = (column: string, resourceType?: ResourceType): boolean => {
  if (!resourceType) return true;
  const allowedTypes = columnResourceTypes[column];
  if (!allowedTypes) return true;
  if (allowedTypes === 'all') return true;
  if (typeof allowedTypes === 'string') return allowedTypes === resourceType;
  if (Array.isArray(allowedTypes)) return allowedTypes.includes(resourceType);
  return false;
};

/**
 * Gets all columns that should be visible for the given resource type
 */
export const getVisibleColumnsForResourceType = (resourceType?: ResourceType): string[] => {
  return Object.keys(columnResourceTypes).filter((column) => isColumnVisibleForResourceType(column, resourceType));
};
